// Presentation-only groupings of existing routes. Access remains with each page.
import { Home, Music2, Mic2, Newspaper, Users, BookOpen, Trophy, Building2, Compass } from "lucide-react";
const artistSections = [
  { id: "overview", label: "Overview & earnings", paths: ["/dashboard", "/dashboard/analytics", "/dashboard/weekly", "/dashboard/payouts"] },
  { id: "create", label: "Create & sell", paths: ["/dashboard/content", "/dashboard/products", "/dashboard/collectibles", "/dashboard/events", "/dashboard/experiences", "/dashboard/subscriptions"] },
  { id: "audience", label: "Audience & growth", paths: ["/messages", "/dashboard/ai-messages", "/dashboard/growth", "/dashboard/promo-codes", "/dashboard/promo-kit", "/dashboard/referrals"] },
  { id: "account", label: "Account & safety", paths: ["/dashboard/profile", "/security/sessions", "/dashboard/security", "/dashboard/trust-safety", "/dashboard/settings"] },
  { id: "admin", label: "Administration", paths: ["/dashboard/admin", "/admin/verifications", "/admin/cra", "/dashboard/admin-inmail", "/dashboard/support"] },
];

export const groupArtistNavigation = (items, { storeFirst = false } = {}) => {
  const used = new Set();
  const sections = storeFirst ? [
    { id: "profile", label: null, paths: ["/dashboard/profile"] },
    { id: "store", label: "Open Store:", paths: ["/dashboard/content", "/dashboard/events", "/dashboard/products", "/seller/orders", "/dashboard/subscriptions"] },
    ...artistSections,
  ] : artistSections;
  const groups = sections.map(section => ({
    id: section.id, label: section.label,
    items: section.paths.flatMap(path => {
      const item = items.find(link => link.path === path);
      if (!item || used.has(item.path)) return [];
      used.add(item.path);
      return [item];
    }),
  })).filter(section => section.items.length);
  const remaining = items.filter(item => !used.has(item.path));
  if (remaining.length) groups.push({ id: "workspace", label: "Workspace", items: remaining });
  return groups;
};

export const publicNavigation = [
  { id: "discover", label: "Discover", items: [
    { path: "/home", label: "Home", icon: Home }, { path: "/fandom", label: "Fandom", icon: Music2 }, { path: "/fandom?tab=artists", label: "Artists", icon: Mic2 },
  ] },
  { id: "community", label: "Connect", items: [
    { path: "/headlines", label: "Headlines", icon: Newspaper }, { path: "/community", label: "Community", icon: Users },
  ] },
  { id: "resources", label: "Learn & participate", items: [
    { path: "/learn", label: "Learn", icon: BookOpen }, { path: "/awards/2027", label: "Top 100", icon: Trophy }, { path: "/sponsors", label: "Sponsors", icon: Building2 }, { path: "/", label: "Welcome", icon: Compass },
  ] },
];

export const adminNavigation = [
  { id: "review", label: "Review & support", items: [
    { path: "/dashboard/admin", label: "Admin home" }, { path: "/admin/awaiting-review", label: "Awaiting review" },
    { path: "/admin/verifications", label: "Verifications" }, { path: "/admin/idol-applications", label: "Idol applications" },
    { path: "/admin/sponsors", label: "Sponsors" }, { path: "/dashboard/admin-inmail", label: "Admin In-Mail" }, { path: "/dashboard/support", label: "Support Inbox" },
  ] },
  { id: "people", label: "People & safety", items: [
    { path: "/admin/buyers", label: "Buyers" }, { path: "/admin/artists", label: "Artists" },
    { path: "/dashboard/trust-safety", label: "Trust & Safety" }, { path: "/admin/leak-detector", label: "Leak Detector" },
  ] },
  { id: "finance", label: "Money & reporting", items: [
    { path: "/admin/payouts", label: "Payouts" }, { path: "/admin/payouts/external", label: "External payouts" },
    { path: "/admin/refunds", label: "Refunds" }, { path: "/admin/tax-buckets", label: "Tax buckets" },
    { path: "/admin/cra", label: "Tax & Reporting" }, { path: "/expenses", label: "Expenses" },
  ] },
];

export const navigationId = value => value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");